<template>
  <mt-swipe
    class="m-swipe"
    :auto="0"
    @click.native="hide"
    :defaultIndex="data.activeIndex"
    :continuous="false"
  >
    <mt-swipe-item v-for="item in data.imgs" key="item.id">
      <img :src="filter(item.src)"
        @mousewheel.prevent
        @DOMMouseScroll.prevent
      >
    </mt-swipe-item>
  </mt-swipe>
</template>

<script>
export default {
  props: {
    data: {
      type: Object
    }
  },

  methods: {
    hide () {
      this.$store.commit('HIDE_SWIPE')
    },

    filter (src) {
      let newSrc = src.replace(/\.thumb/g, '')
      return newSrc
    }
  }
}
</script>



// WEBPACK FOOTER //
// swipe.vue?a7d1d83e